import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import FunctionalCalendar from 'vue-functional-calendar'
import VueScrollTo from 'vue-scrollto'
import qs from 'qs'
import _ from 'lodash'
import { getTodaysDate, formatCalendarDate } from '../registration-form/date-helpers'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueRecaptcha from 'vue-recaptcha'

// Warn user about unsaved changes on navigation away:
function beforeUnload(e) {
  e.preventDefault()
  e.returnValue = ''
}

var lostPetFormEl = document.getElementById('v-lost-pet-form')
if (lostPetFormEl) {
  window.addEventListener('beforeunload', beforeUnload)
}

// Date picker defaults:
Vue.use(FunctionalCalendar)

// Animate page scroll:
Vue.use(VueScrollTo)

// For handling API data:
Vue.use(VueAxios, axios)

let path = '/lost-pet/'

export default Vue.component('lost-pet-form', {
  props: ['isUpdate', 'context', 'isLoggedIn'],
  components: {
    ModelListSelect,
    VueRecaptcha,
  },
  data() {
    const dataset = lostPetFormEl.dataset

    let originalData = {}

    if (this.isUpdate) {
      Object.assign(originalData, window.CANZ?.listingDetails || {})
    } else {
      Object.assign(originalData, window.CANZ?.companionAnimalDetails || {})
      Object.assign(originalData, window.CANZ?.contactDetails || {})
    }

    return {
      listingId: originalData?.listingId,
      companionAnimalId: originalData?.companionAnimalId,
      loading: false,
      step: this.isUpdate || this.context == 'found' ? 1 : 2,
      hasRegisteredMicrochip: !!originalData?.microchipNumber && !!originalData.companionAnimalId,
      microchipClass: this.hasRegisteredMicrochip ? 'c-form-field--disabled' : '',
      regions: window.CANZRegions,
      /*
       * Datepicker requires object for storing date values. Selected date is
       * extracted and converted into expected format on step submit (see below).
       */
      dateLostObject: {
        currentDate: '',
        selectedDate: originalData?.date ? originalData?.date : getTodaysDate(),
        selectedDateTime: false,
        selectedHour: '00',
        selectedMinute: '00',
        selectedDatesItem: '',
        selectedDates: [],
        dateRange: {
          start: '',
          end: '',
        },
        multipleDateRange: [],
      },
      dateFoundObject: {
        currentDate: '',
        selectedDate: originalData?.date ? originalData?.date : getTodaysDate(),
        selectedDateTime: false,
        selectedHour: '00',
        selectedMinute: '00',
        selectedDatesItem: '',
        selectedDates: [],
        dateRange: {
          start: '',
          end: '',
        },
        multipleDateRange: [],
      },
      fields: {
        FormToken: dataset && lostPetFormEl.dataset.token,
        ageYears: originalData?.ageYears ?? '',
        ageMonths: originalData?.ageMonths ?? '',
        breed: originalData?.lostPetBreed ?? '',
        companionName: originalData?.companionName ?? '',
        colourDescription: originalData?.lostPetColour ?? '',
        dateLost: originalData?.date,
        dateFound: originalData?.date,
        desexed: originalData?.desexed ?? '',
        email: originalData?.email ?? '',
        guardianMobileNumber: originalData?.guardianMobileNumber ?? '',
        guardianAlternativeNumber: originalData?.guardianAlternativeNumber ?? '',
        gender: originalData?.gender ?? '',
        listingText: originalData?.listingText ?? '',
        microchipped: originalData?.microchipped ?? '',
        microchipNumber: originalData?.microchipNumber ?? '',
        photoId: originalData?.photoId,
        speciesId: originalData?.speciesId ?? '',
        addressSearch: originalData?.displayAddress ?? '',
        Street: originalData?.Street,
        Suburb: originalData?.Suburb ?? '',
        City: originalData?.City,
        // Lat/Long are set on the Member class for the user's current address
        // Used for initial creation of a listing
        // Street Lat/Long are set on the Listing class - Used for editing a listing
        // Using different names so that on edit it will get the listing address
        // instead of the Member address in case animal was lost away from their house
        Latitude: originalData?.streetLatitude ?? originalData?.Latitude ?? '',
        Longitude: originalData?.streetLongitude ?? originalData?.Longitude ?? '',
        regionId: originalData?.regionId ?? '',
        captchaVerified: this.isLoggedIn || this.isUpdate,
      },
      formErrors: [],
      errors: {},
      originalData,
      response: '',
      showModal: false,
    }
  },
  computed: {
    calcValidationStep() {
      if (this.step === 1) {
        return 'ContactDetails'
      } else if (this.step === 2) {
        return 'AnimalDetails'
      } else {
        return 'ListingDetails'
      }
    },
    totalSteps() {
      return 3
    },
  },
  created: function () {
    let queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    if (this.listingId > 0 && urlParams.get('edit') === 'true') {
      this.step = 3
      return
    }

    if (!this.listingId && this.context === 'lost') {
      this.step = 2
      return
    }

    this.step = 1
    return
  },
  mounted() {
    if (this.step === 3) {
      VueScrollTo.scrollTo(
        document.getElementById('step' + this.step, 400, {
          offset: -75,
          cancelable: false,
        }),
      )
    }
  },
  methods: {
    handleCaptchaSuccess(recaptchaToken) {
      this.response = recaptchaToken

      this.axios({
        method: 'POST',
        url: '/api/verify-captcha',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          recaptchaResponse: this.response,
        }),
        maxRedirects: 0,
      })
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.fields.captchaVerified = true
          } else {
            this.handleErrors(response)
            self.$refs.recaptcha.reset()
          }
        })
        .catch(this.handleErrors)
    },
    handleCaptchaError() {
      console.log('recaptcha error')
    },
    onCaptchaExpired() {
      this.response = ''
      this.fields.captchaVerified = false
    },
    speciesChanged() {},
    submitStep(e) {
      e.preventDefault()

      // Convert date format for datepicker fields
      this.fields.dateLost = formatCalendarDate(this.dateLostObject.selectedDate)
      this.fields.dateFound = formatCalendarDate(this.dateFoundObject.selectedDate)

      this.formErrors = []
      this.errors = {}
      this.loading = true

      const errors = _.clone(this.errors)
      this.doPost()
    },
    doPost(e) {
      let pathWithContext = path + this.context
      let url = this.step === this.totalSteps ? pathWithContext + '/submit' : pathWithContext + '/validate'

      this.axios({
        method: 'POST',
        url,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          ...this.fields,
          step: this.calcValidationStep,
          context: this.context,
          isUpdate: this.isUpdate,
          listingId: this.listingId,
          isCaptchaVerified: this.fields.captchaVerified,
          companionAnimalId: this.context == 'lost' ? this.companionAnimalId : '',
        }),
        maxRedirects: 0,
      })
        .then((response) => {
          if (response?.data?.status === 'success') {
            if (this.step === this.totalSteps) {
              window.removeEventListener('beforeunload', beforeUnload)
              const url = '/lost-pet/' + this.context + '/preview/' + response?.data?.listingId
              window.location = this.isUpdate ? url + '?update=1' : url
            } else {
              this.loading = false
              this.step += 1

              const newStep = document.getElementById('step' + this.step)

              VueScrollTo.scrollTo(newStep, 400, {
                offset: -75,
              })
            }
          } else {
            this.handleErrors({ response })
          }
        })
        .catch(this.handleErrors)
    },
    handleErrors(error) {
      this.loading = false
      const errors = {}
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors || {}).forEach((k) => {
          if (typeof this.fields[k] !== 'undefined') {
            errors[k] = error.response.data.errors[k]
          } else {
            this.formErrors.push(error.response.data.errors[k])
          }
          if (k == 'microchipNumber' && error.response.data.errors[k].code == 'existing-microchip') {
            this.showExistingMCModal()
          }
        })
      } else {
        this.formErrors.push({
          value: 'An unknown error has occurred, please try again, or copy your data and reload the page',
        })
      }
      this.errors = errors

      // Once errors displayed, scroll window to first instance within current step
      this.$nextTick(() => {
        const curStepCard = document.getElementById('v-' + this.calcValidationStep + '-inputs')

        let errorElements = curStepCard?.getElementsByClassName('c-form-field__message--error')
        if (!errorElements?.length) {
          errorElements = document.getElementsByClassName('c-message--error')
        }
        if (errorElements?.length) {
          VueScrollTo.scrollTo(errorElements[0], 400, {
            offset: -75,
          })
        }
      })
    },
    updateFieldValue({ key, value }) {
      this.fields[key] = value
    },
    updateLoading({ value }) {
      this.loading = value
    },
    showExistingMCModal() {
      this.showModal = true
    },
    onModalClose() {
      this.showModal = false
    },
    getTodaysDate,
  },
})
